import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Droppable } from 'react-beautiful-dnd';
import PropTypes from 'prop-types';
import classNames from 'classNames';
import LessonChildWorkspace from '~/components/courses/lesson-child-workspace';
import NewEntity from '~/components/common/new-entity';
import { toggleExpandAll } from '~/redux/actions/workspaceActions';

/**
 * Component for final quizzes
 */
class CourseWorkspaceQuiz extends Component {
	/**
	 * Constructor
	 *
	 * @param {Object} props
	 */
	constructor( props ) {
		super( props );

		this.state = {
			isDropDisabled: true,
			workspace: this.props.workspace.present,
		};
	}

	/**
	 * Check whether the current draggable entity is a quiz so that the Droppable is enabled.
	 *
	 * @param {Object} props
	 * @param {Object} state
	 */
	static getDerivedStateFromProps( props, state ) {
		const workspace = props.workspace.present;
		const prevWorkspace = state.workspace;
		const stateObject = {
			workspace,
		};

		if (
			workspace.currentDraggableEntity !==
				prevWorkspace.currentDraggableEntity &&
			workspace.currentDraggableEntity
		) {
			let isDropDisabled = true;

			// Only Draggable quizzes can be dropped on that Droppable.
			if (
				'quiz' === workspace.currentDraggableEntity.type ||
				'sfwd-quiz' === workspace.currentDraggableEntity.type
			) {
				isDropDisabled = false;
			}

			stateObject.isDropDisabled = isDropDisabled;
		}

		return stateObject;
	}

	/**
	 * Render function
	 */
	render() {
		const { data, workspace } = this.props;
		return (
			<div className="ld__builder--final-quizzes">
				<h3>
					{ LearnDashData.i18n.final_quiz } { data.labels.quizzes }
				</h3>

				{ /* Our main droppable where quizzes can be dropped and reordered */ }
				<Droppable
					droppableId={ JSON.stringify( {
						ID: 'course-workspace-quiz-droppable',
						type: 'course',
					} ) }
					isDropDisabled={ this.state.isDropDisabled }
				>
					{ ( provided, snapshot ) => (
						<div
							ref={ provided.innerRef }
							className={ classNames( {
								'-is-dragging-over': snapshot.isDraggingOver,
							} ) }
						>
							{ /* Loop through all the quizzes in our store */ }
							{ workspace.present.quizzes.map(
								( node, index ) => (
									<LessonChildWorkspace
										key={ node.ID }
										node={ node }
										index={ index }
										indexLesson={ index }
									/>
								)
							) }

							{ /* Placeholder for dropping new quizzes */ }
							<ul
								className="ld__builder--placeholder -quiz"
								data-label={ `${ LearnDashData.i18n.drop_quizzes }` }
							>
								{ provided.placeholder }
							</ul>

							<div className="ld__builder--new-entities">
								<NewEntity type="quiz" position="footer" />
							</div>
						</div>
					) }
				</Droppable>
			</div>
		);
	}
}

/**
 * Valid props
 */
CourseWorkspaceQuiz.propTypes = {
	workspace: PropTypes.shape( {
		present: PropTypes.object,
	} ),
	data: PropTypes.shape( {
		labels: PropTypes.object,
	} ),
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = ( state ) => {
	return {
		workspace: state.workspace,
		data: state.data,
	};
};

/**
 *
 * @param {*} dispatch
 */
const mapDispatchToProps = ( dispatch ) => ( {
	toggleExpandAll: () => dispatch( toggleExpandAll() ),
} );

export default connect(
	mapStateToProps,
	mapDispatchToProps
)( CourseWorkspaceQuiz );
